import { render, staticRenderFns } from "./SlrcD_Details.vue?vue&type=template&id=f1308432"
import script from "./SlrcD_Details.vue?vue&type=script&lang=js"
export * from "./SlrcD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports